import React from 'react';
import './App.css';
import Calculator from "./calculator"

function App() {
  return (
    <Calculator />
  );
}

export default App;
